'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Flow Mix Chart
 */
var FlightMarketMixGraphTransformationFactory = function FlightMarketMixGraphTransformationFactory($filter, DataTransformer, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function FlightMarketMixGraphTransformation() {
    DataTransformer.call(this);
    this.sourceType = ['service'];
    this.targetType = 'market-mix-graph';
    this.priority = 1;
  }
  FlightMarketMixGraphTransformation.prototype = Object.create(DataTransformer.prototype);
  FlightMarketMixGraphTransformation.constructor = FlightMarketMixGraphTransformation;
  FlightMarketMixGraphTransformation.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) > -1 && this.targetType === targetType;
  };
  FlightMarketMixGraphTransformation.prototype.isCacheable = function () {
    return true;
  };
  FlightMarketMixGraphTransformation.prototype.getCacheKey = function (metrics) {
    return this.sourceType.join('-') + '-' + metrics.join('-');
  };
  function complexMetricPopulateFunction(newEntry, entry, metrics, metricsKeys, mlength) {
    for (var i = 0, length = mlength; i < length; i++) {
      var curMetric = metrics[i];
      newEntry[metricsKeys[i]] = [entry[curMetric[0]], entry[curMetric[1]]];
    }
  }
  function singleMetricPopulateFunction(newEntry, entry, metrics, metricsKeys, mlength) {
    for (var i = 0, length = mlength; i < length; i++) {
      var curMetric = metrics[i];
      newEntry[metricsKeys[i]] = entry[curMetric];
    }
    return newEntry;
  }
  FlightMarketMixGraphTransformation.prototype.transform = function (data, metrics) {
    var metricsKeys = [];
    var mlength = metrics.length;
    for (var m = 0; m < mlength; m++) {
      metricsKeys[m] = 'm' + (m + 1);
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var metricPopulateFunction;
    if (_.isArray(metrics[0])) {
      metricPopulateFunction = complexMetricPopulateFunction;
    } else {
      metricPopulateFunction = singleMetricPopulateFunction;
    }
    var result = [];
    var marketData = data.domain.serviceClassPOS || data.domain.results;
    for (var i = 0, length = marketData.length; i < length; i++) {
      var entry = marketData[i];
      var momentDepartureDate = memoizedMomentOfDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
      var curYMD = memoizedYearMonthDayOfMoment(momentDepartureDate);
      var newEntry = {
        market: entry.origin + '-' + entry.destination,
        bookingsCurrent: entry.regularReservationHoldingsTotal,
        departureDate: curYMD
      };
      metricPopulateFunction(newEntry, entry, metrics, metricsKeys, mlength);
      result.push(newEntry);
    }
    return result;
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return FlightMarketMixGraphTransformation;
};
FlightMarketMixGraphTransformationFactory.$inject = ['$filter', 'DataTransformerFactory', 'MomentService'];
module.exports = FlightMarketMixGraphTransformationFactory;